// src/components/Reports/ReportControls.js
import React from 'react';
import { Card, Button, Row, Col, Form } from 'react-bootstrap';

const ReportControls = ({ reportType, setReportType, dateRange, setDateRange }) => {
    return (
        <Card className="mb-4 shadow-sm">
            <Card.Body className="p-4">
                <Row>
                    <Col lg={6} className="mb-4 mb-lg-0">
                        <Form.Group>
                            <Form.Label className="fw-bold">Typ reportu</Form.Label>
                            <div className="d-flex flex-wrap gap-2">
                                <Button
                                    variant={reportType === 'uptime' ? 'primary' : 'outline-primary'}
                                    onClick={() => setReportType('uptime')}
                                    className="px-3 py-2"
                                >
                                    <i className="fas fa-clock me-2"></i> Dostupnost
                                </Button>
                                <Button
                                    variant={reportType === 'performance' ? 'primary' : 'outline-primary'}
                                    onClick={() => setReportType('performance')}
                                    className="px-3 py-2"
                                >
                                    <i className="fas fa-tachometer-alt me-2"></i> Výkon
                                </Button>
                                <Button
                                    variant={reportType === 'security' ? 'primary' : 'outline-primary'}
                                    onClick={() => setReportType('security')}
                                    className="px-3 py-2"
                                >
                                    <i className="fas fa-shield-alt me-2"></i> Bezpečnost
                                </Button>
                                <Button
                                    variant={reportType === 'seo' ? 'primary' : 'outline-primary'}
                                    onClick={() => setReportType('seo')}
                                    className="px-3 py-2"
                                >
                                    <i className="fas fa-search me-2"></i> SEO
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>

                    <Col lg={6}>
                        <Form.Group>
                            <Form.Label className="fw-bold">Časové období</Form.Label>
                            <div className="d-flex flex-wrap gap-2">
                                <Button
                                    variant={dateRange === '7days' ? 'primary' : 'outline-primary'}
                                    onClick={() => setDateRange('7days')}
                                    className="px-3 py-2"
                                >
                                    7 dní
                                </Button>
                                <Button
                                    variant={dateRange === '30days' ? 'primary' : 'outline-primary'}
                                    onClick={() => setDateRange('30days')}
                                    className="px-3 py-2"
                                >
                                    30 dní
                                </Button>
                                <Button
                                    variant={dateRange === '90days' ? 'primary' : 'outline-primary'}
                                    onClick={() => setDateRange('90days')}
                                    className="px-3 py-2"
                                >
                                    90 dní
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ReportControls;